// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor-node_modules_fortawesome_free-solid-svg-icons_faArrowsLeftRight_js-node_modules_fortaw-273e3b"], () => (__webpack_require__("./index.tsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
